import { render, staticRenderFns } from "./pos-checkout-drawer.vue?vue&type=template&id=2df2b8ea&scoped=true&"
import script from "./pos-checkout-drawer.ts?vue&type=script&lang=ts&"
export * from "./pos-checkout-drawer.ts?vue&type=script&lang=ts&"
import style0 from "./pos-checkout-drawer.scss?vue&type=style&index=0&id=2df2b8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2b8ea",
  null
  
)

export default component.exports